/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 20.06.2016
 *
 */
import React from 'external/react';
import Title from './Title';
import { Container } from 'external/react-bootstrap';

import wrapWithCommonFormContainer from './CommonFormContainer';

const ConfirmFormContainer = wrapWithCommonFormContainer(({ title, Content, ...otherProps }) => (

        <Container className="py-3">
            {title && <Title title={title}/>}
            {typeof Content === 'string' ? Content : <Content {...otherProps} />}
        </Container>
    )
);

export default ConfirmFormContainer;



// WEBPACK FOOTER //
// ./js/components/ConfirmFormContainer.jsx